// mobile layout actions
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP'
//cupon
export const SET_CUPON = 'SET_CUPON'
//Cart validation
export const SET_CHANGED_PRODUCTS = 'SET_CHANGED_PRODUCTS'
export const CLEAR_CHANGED_PRODUCTS = 'CLEAR_CHANGED_PRODUCTS'
export const SET_OBSERVATION = 'SET_OBSERVATION'